export default __webpack_public_path__ + "static/media/Mobile_Mock.47b625f0.png";